module.exports = __webpack_public_path__ + "static/media/christine_park.447a269d.png";